import { CameraSource } from '@capacitor/camera';

/**
 * Result returned by a photo picker strategy.
 */
export interface PhotoPickerResult {
    fileName: string;
    base64Data: string;
}

/**
 * Strategy interface for picking photos across different platforms.
 * Implementations handle platform-specific details (native vs web).
 */
export interface PhotoPickerStrategy {
    /**
     * Pick a photo from the specified source.
     *
     * @param source - Camera source (Camera or Photos library)
     * @returns Promise resolving to photo data, or null if cancelled
     * @throws Error if photo picking fails
     */
    pickPhoto(source: CameraSource): Promise<PhotoPickerResult | null>;

    /**
     * Check if this strategy is available on the current platform.
     */
    isAvailable(): boolean;
}
